
import { ModuloService } from '../parametricas/shared/modulo.service';
import { InfoUserService } from '../info-user/shared/info-user.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GenericResult } from '../globalClass/generic-class.model';
import { CryptoService } from '../shared/crypto/crypto.service';
import { UserInfo } from '../info-user/shared/user-info.model';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  
  sarlaftMenu: boolean = false;
  siniestroMenu: boolean = false;
  pacsMenu: boolean = false;
  administracionComercialMenu = false;
  weCumplimientoMenu: boolean = false;
  searchMenu: boolean = true;

  constructor(
    private jwtHelper: JwtHelperService,
    private encryptService: CryptoService,
    private _moduleService: ModuloService,
    private _userInfo: InfoUserService,
    private _chdr: ChangeDetectorRef,
    private _infoUserService: InfoUserService,
  ) { }

  ngOnInit() {
    this.getModules();
  }

  getModules() {
    this._userInfo.getDataUser().then((r) => {
      if (r != null) {
        let modules: any[] = [];
        if (typeof (r.modules) != 'undefined') {
          modules = r.modules;
          this.setModule(r.modules);
        }
      }
    });    
  }

  setModule = async (module: any[]) => {
    await this._moduleService.setModules(module);
    this.pacsMenu = this._moduleService.pacsMenu;
    this.administracionComercialMenu = this._moduleService.administracionComercialMenu;
    this.siniestroMenu = this._moduleService.siniestrosMenu;
    this.sarlaftMenu = this._moduleService.sarlaftMenu;
    this.weCumplimientoMenu = this._moduleService.weCumplimientoMenu;
    this._chdr.detectChanges();
  }

  isChangeCompany(value) {
    //debugger;
    if (value) {
      this.getModules();
    }
  }
}
